<template>
  <template v-if="question?.status !== 'READ_ONLY'">
    <div
        v-bind="$attrs"
        class="inputContainer"
        :class="{'btn-group': true, error: (question.error || displayError) && hasBeenInteractedWith}"
        role="group"
        aria-label="Basic toggle button group">
      <template v-for="(option, index) in question.options" :key="index">
        <input
            type="radio"
            class="btn-check"
            :name="`${question.name}`"
            :id="`${question.name}-radio-${option.value}`"
            :disabled="disabled"
            autocomplete="off"
            :value="option.value"
            :checked="option.value === value"
            @click.stop="$emit('user-interaction');setChoiceValue(option.value)"
        />

        <label
            :class="['btn',
              (question.error || displayError) && hasBeenInteractedWith ? 'error' : '',
              question.options.length <= 3 ? 'btn-outline-dark' : 'btn-outline-dark resize']"
            :for="`${question.name}-radio-${option.value}`" :id="`${question.name}-label-${option.value}`" v-html="option.text"></label>
      </template>
    </div>
    <slot name="helptext" :isError="displayError" :isConfirm="!disableConfirm && (question.value && question.prefilled) && !displayError"
          :confirmCb="() => {$emit('user-interaction');$emit('confirm')}"></slot>
  </template>
  <ReadOnly
      v-else
      :question="question"
      :value="this.value ? `${this.value}`:'-'"
      :forcePromptPlaceholder="forcePromptPlaceholder"
  />
</template>

<script>

import ReadOnly from "@/components/waffle/components/form-components/ReadOnly.vue";

export default {
  name: 'BoxToggle',
  components: {ReadOnly},
  emits: ['update:modelValue', 'field-error','confirm','user-interaction'],
  props: ['question', 'modelValue', 'hideSubText', 'skipEagerValidation','disableConfirm','forcePromptPlaceholder', 'hasBeenInteractedWith','disabled'],
  data() {
    return {
      value: "",
      displayError: '',
    }
  },
  mounted() {
    this.value = this.question.value
    this.displayError = this.question.error
    if (!this.skipEagerValidation) {
      this.validate(this.question.error)
    }
    this.$emit('update:modelValue', this.value);
  },
  watch: {
    question: {
      handler(newQuestion) {
        if (newQuestion.value !== undefined) {
          if(newQuestion.value !== this.value){
            this.$emit('update:modelValue', newQuestion.value);
          }
          this.value = newQuestion.value
        }

        if (newQuestion.error) {
          this.displayError = newQuestion.error
        } else {
          this.displayError = ''
        }
      },
      deep: true,
    }
  },
  methods: {
    validate(backendError){
      if(backendError){
        this.$emit('field-error', true)
        this.displayError = backendError
        return true
      }

      const required = this.question.required
      if (required && !this.value && (this.hasBeenInteractedWith && !this.skipEagerValidation || true)) {
        this.$emit('field-error', true)
        this.displayError = 'Required. '
        return true
      }
      this.$emit('field-error', false)
      this.displayError = ''
      return false
    },
    setChoiceValue(v) {
      if(this.value !== v){
        this.value = v
        this.$nextTick(() => {
          if(!this.validate()){
            return this.$emit('update:modelValue', this.value);
          }
        })
      }
    }
  }

}
</script>

<style scoped lang="scss">
.align-text-end {
  text-align: end;
}


label.btn-outline-dark {
  width: 105px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #bdbdbd !important;

  &.resize {
    width: 45px;
  }


  &:hover {
    color: white;
    background: #212121 !important;
  }

  &:active {
    color: white;
    background: #212121 !important;
  }

  &:not(:first-child):not(:last-child) {
    border-right: 0;
  }
}


.subtext {
  font-size: 12px;
  color: #757575;
}

.error {
  border-color: #BB0000 !important;
  color: #BB0000
}

.errorMessage {
  color: #BB0000
}

.btn-group {
  width: 100%;
  height: 51px;

}

.btn-group > .btn:first-of-type {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  border-right: 1px solid #bdbdbd;
}


.btn-group > .btn:last-child {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}
.btn-check:focus-visible,
.btn-check:focus,
.btn-check:focus-visible + label{
  box-shadow: none !important;
  outline: 0;
}

</style>